
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alternatives/doubletick",
      function () {
        return require("private-next-pages/alternatives/doubletick.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alternatives/doubletick"])
      });
    }
  